<template>
  <main class="content" style="min-height: 800px;">
    <Navbar />
    <div class="container">
      <div class="row">
        <div class="col-lg-3 pt-4 border-right">
          <Sidenav />
        </div>
        <div class="col-lg-9">
          <b-overlay :show="overlayLoading" rounded="sm" class="mb-5 pb-3">
            <div v-html="transformContent" class="pt-5 px-4"></div>
          </b-overlay>
        </div>
      </div>
    </div>
    <Footer />
  </main>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Sidenav from "@/components/page/Sidenav.vue";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
export default {
  components: {
    Sidenav,
    Navbar,
    Footer
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("merchant", {
      customerPortalToken: state => state.customerPortalToken
    }),
    ...mapGetters({
      termsOfUse: "page/termsOfUse",
      overlayLoading: "page/overlayLoading"
    }),
    transformContent() {
      return this.termsOfUse !== null && this.termsOfUse.includes("\n")
        ? this.termsOfUse
            .split("\n")
            .map(content => {
              return `<p>${content}</p>`;
            })
            .join("")
        : this.termsOfUse;
    }
  },
  watch: {
    customerPortalToken(token) {
      const request = {
        header: {
          "X-Merchant-Token": token
        }
      };
      this.getCustomerPages(request);
    }
  },
  methods: {
    ...mapActions({
      getCustomerPages: "page/getCustomerPages"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "./../assets/styles/views/page/_base.scss";
.container > .row {
  min-height: calc(100vh - 135px);
}
@media (max-width: 992px) {
  .container > .row > .border-right {
    border-right: 0 !important;
  }
}
</style>
